import { createFileRoute, redirect } from "@tanstack/react-router";
import LoadingPage from "lib/components/layout/LoadingPage";
import { errorPath } from "lib/routeHelpers";

/**
 * Public post-CTA confirmation page for a saved `HomePlan`. Shows the
 * selected options summary, pricing breakdown, and brochure download — the
 * landing page a buyer sees after submitting their plan.
 */
function ShowroomPlanOverview() {
  return <LoadingPage pageTitle="Showroom" />;
}

export const Route = createFileRoute("/showroom/plan/$home_plan_id/overview")({
  // Gate at the route level. See `apps/web/pages/showroom/index.tsx` for the
  // hydration-deferral rationale.
  beforeLoad: ({ context }) => {
    if (!context.flagsHydrated) {
      return;
    }
    if (!context.enabledFeatures.showroomUnification) {
      throw redirect({ to: errorPath(403, undefined, "This feature is not enabled for your account.") });
    }
    if (!context.enabledProducts.showroom) {
      throw redirect({
        to: errorPath(403, undefined, "The product you are trying to access is not enabled for this organization."),
      });
    }
  },
  component: ShowroomPlanOverview,
  staticData: { isPublicPage: true },
});
